import { AvatarSize, Box } from '@bechtel/gds';
import { css, default as styled } from 'styled-components';

interface AvatarPlaceholderStyledProps {
  size?: AvatarSize;
  showIcon?: boolean;
}

const getAvatarSize = ({ size }: AvatarPlaceholderStyledProps) => {
  switch (size) {
    case AvatarSize.SMALL:
      return css`
        width: 30px;
        height: 30px;
      `;
    case AvatarSize.MEDIUM:
      return css`
        width: 40px;
        height: 40px;
      `;
    case AvatarSize.LARGE:
      return css`
        width: 50px;
        height: 50px;
      `;
    default:
      return css`
        width: 50px;
        height: 50px;
      `;
  }
};

export const AvatarSectionStyled = styled(Box).attrs({
  mt: { sm: '100' },
  mb: { sm: '100' },
  p: { sm: '100' },
})<AvatarPlaceholderStyledProps>`
  flex-shrink: 0;
  ${getAvatarSize}
`;

export const AvatarPlaceholderStyled = styled(Box).attrs({
  flesGrow: { sm: 1 },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})<AvatarPlaceholderStyledProps>`
  ${({ theme, showIcon }) => css`
    background-color: ${!showIcon ? theme.colors.primary[700] : theme.colors.grey[100]};
    color: ${theme.colors.white};
    height: 100%;
    width: 100%;
    border-radius: 28px;
    border: 1px solid ${!showIcon ? theme.colors.primary[700] : 'transparent'};
  `}
`;
